<template>
  <v-dialog v-model="loading" width="300" style="z-index: 1021;">		
      <v-card style="">
        <v-card-text class="pt-6">
          <v-progress-linear
            indeterminate
            color="indigo"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
	</v-dialog>
</template>

<script>
 
export default {
  name: 'LoadingDialog', 
  props: ['loading'],
  data () {
    return {
    }
  }, 
}
</script>